import EventEmitter from "eventemitter3";
import { settingModalState, viewState } from "./viewState";

/**
 * Событие перехода на другую страницу
 * Используется чтобы почистить состояния модалок
 * при внезапном неявном переходе на другую страницу
 */
export const transitionEvents = new EventEmitter();

const resetModals = () => {
  viewState.detailDialog = false;
  settingModalState.value = false;
};

transitionEvents.addListener("active", resetModals);

transitionEvents.addListener("finish", resetModals);

transitionEvents.addListener("start", resetModals);
